
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 7v10H4V7h16zm2-2H2v14h20V5z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13 7.75c-1.62 0-3.011.917-3.728 2.25H8l-.25 1.5H8.8c-.02.166-.05.329-.05.5 0 .171.031.334.05.5H8L7.75 14h1.522c.717 1.333 2.108 2.25 3.728 2.25.993 0 1.895-.355 2.618-.926l-.748-.998A2.966 2.966 0 0113 15c-.883 0-1.67-.391-2.22-1h1.72l.25-1.5h-2.699A2.953 2.953 0 0110 12c0-.171.023-.336.051-.5h2.866l.25-1.5H10.78c.55-.609 1.337-1 2.22-1a2.97 2.97 0 011.87.673l.748-.998A4.213 4.213 0 0013 7.75z","fill":"currentColor"}})])
          )
        }
      }
    